<template>
  <div class="box p-a">
    <transition 
      name="fade" 
      mode="out-in">
      <div 
        v-if="all_loading" 
        key="progress" 
        class="progress-container">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>
      <div 
        v-else 
        key="content" 
        class="content">
        <div class="pull-left m-r">
          <span 
            v-if="icon" 
            :class="iconClass">
            <i
              class="material-icons"
              v-html="icon" />
          </span>
        </div>
        <div class="clear">
          <span v-if="data != null">
            <h4 class="m-a-0 text-lg _300">{{ prefix }} {{ value }} {{ suffix }}</h4>
          </span>
          <span v-else>
            <h4 class="m-a-0 text-lg _300">{{ prefix }} 0 {{ suffix }}</h4>
          </span>
          <small class="text-muted">{{ subtitle }}</small>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Laravel from '../laroute';

export default {
    props: {
        prefix: {
            type: String,
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        api: {
            type: String,
            default: null,
        },
        outlet: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: '',
        },
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: true,
        },
        data: {
            type: String | Number,
            default: null,
        },
    },

    data() {
        return {
            api_data: null,
            api_loading: false,
        };
    },

    computed: {
        api_route() {
            return Laravel.route(this.api, { id: this.outlet });
        },

        all_loading() {
            return this.loading || this.api_loading;
        },

        value() {
            if (this.api) {
                return this.api_data;
            }

            return this.data;
        },
    },

    watch: {
        outlet() {
            this.getApiValue();
        },
    },

    created() {
        this.getApiValue();
    },

    methods: {
        getApiValue() {
            if (!this.api) {
                return;
            }

            this.api_loading = true;

            let options = {
                params: this.getParams(),
            };

            this.$http.get(this.api_route, options).then(response => {
                this.api_data = response.data.data;
                this.api_loading = false;
            });
        },

        getParams() {
            let obj = {};

            let start = this.getStartDate();
            let end = this.getEndDate();

            if (start != null) {
                obj.start = start;
            }

            if (end != null) {
                obj.end = end;
            }

            return obj;
        },

        getDate(date) {
            if (date != null) {
                return m(date).format('YYYY-MM-DD hh:mm:ss');
            }

            return null;
        },

        getStartDate() {
            return this.getDate(this.start);
        },

        getEndDate() {
            return this.getDate(this.end);
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.progress-container {
    width: 100%;
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/MetricSummary.vue